import { NgModule, Component, Input, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'detail-view',
    templateUrl: 'detail-view.template.html',
    styleUrls: ['detail-view.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailView {
    @Input() item: any;

    /**
     * SeriesDetail component
     */
    constructor(private coreEffects: CoreEffects, private cd: ChangeDetectorRef, ) {
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/detail-view/detail-view.component.ts